"use client"

import type { WhyChooseUsProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { ImageUploadField } from "../../../lib/ImageUploadField"
import { commonStylesProps } from "../../../lib/commonCSSProps"
import { RenderConfig } from "./RenderConfig"

export const WhyChooseUs: ComponentConfig<WhyChooseUsProps> = {
  label: "Tamda OC | Why Choose Us",
  fields: {
    title: {
      label: "Title",
      type: "text",
      placeholder: "TẠI SAO CHỌN TAMDA OBCHODNÍ CENTRUM?",
    },
    items: {
      label: "Items",
      type: "array",
      getItemSummary: (item: any, index = 0) => item?.title || `Item ${index + 1}`,
      arrayFields: {
        image: {
          label: "Image",
          type: "custom",
          render: (props: any) => <ImageUploadField {...props} />,
        },
        title: {
          label: "Title",
          type: "text",
        },
      },
      defaultItemProps: {
        image: "",
        title: "",
      },
    },
    ...(commonStylesProps as any),
  },
  defaultProps: {
    title: "",
    items: [],
    className: "",
    styles: {
      mobile: {
        display: "block",
      },
      tablet: {
        display: "block",
      },
      desktop: {
        display: "block",
      },
    },
    responsiveType: "mobileFirst",
    animation: {
      "data-aos": "",
      "data-aos-duration": "",
    },
  },
  ...RenderConfig,
}

export type { WhyChooseUsItem, WhyChooseUsProps } from "@/types/types"
